import { CustomerUsersQueryParams } from '../customers/types';
import {
	CustomerUserResponse,
	CreateUserRequest,
	RoleResponse,
	UpdateUserRequest,
	UserResponse,
	UsersQueryParams,
	LogsResponse,
	LogsMetaResponse,
} from './types';
import { httpClient } from '../http';
import { NoContent, PaginatedResponse, MutationRequest } from '../types';

export const getMetaLogs = async (queryParams?: UsersQueryParams): Promise<LogsMetaResponse> => {
	const { data } = await httpClient.get<LogsMetaResponse>('/logs/all/meta', {
		params: queryParams,
	});

	return data;
};

export const getAllAdminLogs = async (
	queryParams?: any
): Promise<PaginatedResponse<LogsResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<LogsResponse>>('/logs/all', {
		params: queryParams,
	});

	return data;
};

export const getAllAdminUsers = async (
	queryParams?: UsersQueryParams
): Promise<PaginatedResponse<UserResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<UserResponse>>('/users/admins', {
		params: queryParams,
	});

	return data;
};

export const getAllUsers = async (
	queryParams?: CustomerUsersQueryParams
): Promise<PaginatedResponse<CustomerUserResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<CustomerUserResponse>>('/users', {
		params: queryParams,
	});

	return data;
};

export const getUsersBySite = async (
	siteId: string,
	queryParams?: CustomerUsersQueryParams
): Promise<PaginatedResponse<CustomerUserResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<CustomerUserResponse>>(
		`/sites/${siteId}/users`,
		{ params: queryParams }
	);

	return data;
};

export const createUser = async ({
	request,
	formKey,
}: MutationRequest<CreateUserRequest>): Promise<UserResponse> => {
	const { data } = await httpClient.post<UserResponse>('/users/create', request, {
		headers: { formKey },
	});

	return data;
};

export const updateUser = async (
	id: string,
	{ request, formKey }: MutationRequest<UpdateUserRequest>
): Promise<UserResponse> => {
	const { data } = await httpClient.patch<UserResponse>(`/users/${id}`, request, {
		headers: { formKey },
	});

	return data;
};

export const deleteUser = async (id: string): Promise<NoContent> => {
	const { data } = await httpClient.delete<NoContent>(`/users/${id}`);

	return data;
};

export const sendTemporaryPassword = async (id: string): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>(`/users/${id}/temporary-password`);

	return data;
};

export const getRoles = async (): Promise<RoleResponse[]> => {
	const { data } = await httpClient.get<RoleResponse[]>('/users/roles');

	return data;
};

export const getRolesHierarchy = async (): Promise<RoleResponse[]> => {
	const { data } = await httpClient.get<RoleResponse[]>('/users/roles/hierarchy');

	return data;
};
